import React from "react";
import * as Yup from 'yup';
import { BruciatoreDataDto } from "../../generated"
import { Forms } from "../../common/components/CmForms";
import { MarcaBruciatoreAutocomplete } from "../../marcheBruciatori/components/marcaBruciatoreSelector";
const { Form, FormText, FormFloat, ActionBar } = Forms<BruciatoreDataDto>();

interface Props {
    bruciatore: BruciatoreDataDto | null;
    onSubmit: (bruciatore: BruciatoreDataDto) => void;
    onCancel: () => void;
}


export default class BruciatoreForm extends React.Component<Props> {

    private static validationSchema = Yup.object<Partial<BruciatoreDataDto>>({
        marcaBruciatore: Yup
            .string()
            .required('Campo obbligatorio'),
        modelloBruciatore: Yup
            .string()
            .required('Campo obbligatorio'),
        campoFunzionamentoDa: Yup
            .number()
            .required('Campo obbligatorio'),
        campoFunzionamentoA: Yup
            .number()
            .required('Campo obbligatorio'),
    })

    render() {
        const { bruciatore } = this.props;
        if (!bruciatore)
            return null;
        return (
            <Form
                onSubmit={this.props.onSubmit}
                initialValues={bruciatore}
                validationSchema={BruciatoreForm.validationSchema}
            >
                {
                    ({ set, values, errors }) =>
                        <div className="card card-outline-info">
                            <div className="card-header text-white">Dati Modello Bruciatore</div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <MarcaBruciatoreAutocomplete
                                            label="Marca"
                                            onChange={marca => set("marcaBruciatore", marca ?? undefined)}
                                            value={values.marcaBruciatore}
                                            error={errors.marcaBruciatore}
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <FormText
                                            name="modelloBruciatore"
                                            label="Modello"
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <FormFloat
                                            name="campoFunzionamentoDa"
                                            label="Campo Funz. Da"
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <FormFloat
                                            name="campoFunzionamentoA"
                                            label="Campo Funz. A"
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <FormText
                                            name="tipoBruciatore"
                                            label="Tipo Bruciatore"
                                        />
                                    </div>
                                </div>
                                <ActionBar
                                    onCancel={this.props.onCancel}
                                />
                            </div>
                        </div>
                }
            </Form>
        );
    }
}
